import { Loader } from "@googlemaps/js-api-loader"
import selectize from 'selectize'

const $ = jQuery

export default function GoogleMaps () {
  const containers = document.querySelectorAll('.mtt-google-maps')
  if (containers.length) {
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i]
      const googleMaps = new NewGoogleMaps(container)
      googleMaps.init()
    }
  }
}

class NewGoogleMaps {
  constructor (container) {
    this.container = container
    this.mapContainer = this.container.querySelector('.mtt-google-maps__map-container')
    this.map = this.container.querySelector('#map')
    this.locationsAttr = this.map.getAttribute('data-locations')
    this.locationsArray = JSON.parse(this.locationsAttr)
    this.expandBtn = this.container.querySelector('.mtt-google-maps__expand-button')
    this.apiKey = main_theme_objects.google_maps_api_key
    this.infoWindows = []

    const lat = this.map.getAttribute('data-lat')
    const lng = this.map.getAttribute('data-lng')
    this.coordinates = {
      lat: lat ? parseFloat(lat) : 56.331217612898016,
      lng: lng ? parseFloat(lng) : 9.3772379335693
    }

    this.init = () => {
      this.addMap()
      this.expandMapOption()
    }
  }

  addMap () {
    this.loader = new Loader({
      apiKey: this.apiKey !== null && this.apiKey !== '' ? this.apiKey : 'AIzaSyDDdhEKReJVpiyp0IqXYHX-KR7pmb1oFBw',
      version: 'weekly'
    })

    this.loader.load().then(() => {
      this.googleMap = new google.maps.Map(this.map, {
        center: this.coordinates,
        zoom: 3,
        mapId: '59a4f83f40439015',
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      })

      if (this.locationsArray.length > 0) {
        for (let i = 0; i < this.locationsArray.length; i++) {
          const location = this.locationsArray[i]
          this.addMarkers(location, this.addInfoWindow(location))
        }
      }
    })
  }

  expandMapOption () {
    if (this.expandBtn) {
      this.expandBtn.addEventListener('click', () => {
        this.toggleButton()
      })
    }
  }

  addInfoWindow (location) {
    const infoWindow = new google.maps.InfoWindow({
      content: this.getContentString(location)
    })
    this.infoWindows.push(infoWindow)
    return infoWindow
  }

  addMarkers (location, infoWindow) {
    const map = this.googleMap
    const icon = this.getIcon()

    if (location.latitude && location.longitude) {

      const marker = new google.maps.Marker({
        position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
        map,
        title: location.title,
        icon: icon,
        id: location.id
      })

      marker.addListener('click', () => {
        if (this.infoWindows.length > 0) {
          for (let i = 0; i < this.infoWindows.length; i++) {
            this.infoWindows[i].close()
          }
        }
        infoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false
        })
      })

      if (location.images.length) {
        this.addGallery()
      }
    }
  }

  toggleButton () {
    this.expandBtn.classList.toggle('expanded')
    this.mapContainer.classList.toggle('expanded')

    if (this.expandBtn.classList.contains('expanded')) {
      this.expandBtn.querySelector('.text').innerHTML = 'Close map'
    } else {
      this.expandBtn.querySelector('.text').innerHTML = 'Expand map'
    }
  }

  getContentString (location) {
    let contentString = ''

    // Add images and bullets
    let bullets = ''
    let imagesString = ''
    if (location.images !== null && location.images.length) {
      for (let i = 0; i < location.images.length; i++) {
        const image = location.images[i]
        if (i === 0) {
          imagesString += `<div class="object-fit"><img src="${image}" alt="Image ${i}" data-id="${i}" /></div>`
          bullets += `<div class="bullet active" data-id="${i}"> </div>`
        } else {
          imagesString += `<div class="object-fit"><img src="" data-src="${image}" alt="Image ${i}" data-id="${i}" style="display: none" /></div>`
          bullets += `<div class="bullet" data-id="${i}"> </div>`
        }
      }
    }

    // Add title string
    let titleString = ''
    if (location.title !== null) {
      titleString = `<div class="info-box__title">${location.title}</div>`
    }

    // Add address string
    let addressString = ''
    if (location.address !== null) {
      addressString = `<div class="info-box__field">${location.address}</div>`
    }

    // Add email string
    let emailString = ''
    if (location.email !== null) {
      emailString = `
        <div class="info-box__field">
          <a href="mailto:${location.email}">${location.email}</a>
        </div>
      `
    }

    // Add telephone string
    let telephoneString = ''
    if (location.telephone !== null) {
      telephoneString = `
        <div class="info-box__field">
          <a href="tel:${location.telephone.replace(/\s+/g, '')}">${location.telephone}</a>
        </div>
      `
    }

    // Add link string
    let linkString = ''
    const href = location.link !== null && location.link !== undefined ? ` href="${location.link}"` : ''

    if (location.linkText !== null) {
      linkString = `
        <div class="info-box__field info-box__field--link">
          <a class="inline-button" data-id="${location.id}"${href}>${location.linkText}</a>
        </div>
      `
    }

    contentString = `
      <div class="info-box">
        <div class="info-box__images">
          ${imagesString}
          <div class="bullets">${bullets}</div>
        </div> 
        <div class="info-box__text-wrapper">
          ${titleString}
          ${addressString}
          ${emailString}
          ${telephoneString}
          ${linkString}
        </div>
      </div>
    `

    return contentString
  }

  getIcon () {
    return {
      path: 'M1.125 8.375C1.125 6.28642 1.95469 4.28338 3.43153 2.80653C4.90838 1.32969 6.91142 0.5 9 0.5C11.0886 0.5 13.0916 1.32969 14.5685 2.80653C16.0453 4.28338 16.875 6.28642 16.875 8.375C16.875 11.1864 15.6281 14.0765 14.3064 16.3642C13.3423 18.0205 12.2356 19.5896 10.9989 21.0537C10.8779 21.1948 10.7276 21.3077 10.5586 21.3848C10.3895 21.4619 10.2056 21.5012 10.0198 21.5H7.98019C7.79415 21.5014 7.61005 21.4621 7.44073 21.3851C7.2714 21.308 7.12091 21.1949 6.99975 21.0537C5.76352 19.5896 4.65727 18.0205 3.69356 16.3642C2.37187 14.0778 1.125 11.1864 1.125 8.375ZM9 1.8125C7.25952 1.8125 5.59032 2.5039 4.35961 3.73461C3.1289 4.96532 2.4375 6.63452 2.4375 8.375C2.4375 10.8386 3.54525 13.4846 4.83019 15.7079C5.75107 17.2895 6.80721 18.7882 7.98675 20.1875H10.0132C11.1928 18.7882 12.2489 17.2895 13.1698 15.7079C14.4548 13.4846 15.5625 10.8386 15.5625 8.375C15.5625 6.63452 14.8711 4.96532 13.6404 3.73461C12.4097 2.5039 10.7405 1.8125 9 1.8125ZM9 5.75C8.30381 5.75 7.63613 6.02656 7.14385 6.51885C6.65156 7.01113 6.375 7.67881 6.375 8.375C6.375 9.07119 6.65156 9.73887 7.14385 10.2312C7.63613 10.7234 8.30381 11 9 11C9.69619 11 10.3639 10.7234 10.8562 10.2312C11.3484 9.73887 11.625 9.07119 11.625 8.375C11.625 7.67881 11.3484 7.01113 10.8562 6.51885C10.3639 6.02656 9.69619 5.75 9 5.75ZM5.0625 8.375C5.0625 7.33071 5.47734 6.32919 6.21577 5.59077C6.95419 4.85234 7.95571 4.4375 9 4.4375C10.0443 4.4375 11.0458 4.85234 11.7842 5.59077C12.5227 6.32919 12.9375 7.33071 12.9375 8.375C12.9375 9.41929 12.5227 10.4208 11.7842 11.1592C11.0458 11.8977 10.0443 12.3125 9 12.3125C7.95571 12.3125 6.95419 11.8977 6.21577 11.1592C5.47734 10.4208 5.0625 9.41929 5.0625 8.375Z',
      fillColor: '#fff',
      fillOpacity: 1,
      size: new google.maps.Size(18, 22),
      anchor: new google.maps.Point(9, 22),
      strokeWeight: 1,
      strokeColor: '#fff',
      scale: 1
    }
  }

  addGallery () {
    $(document).on('click', '.bullet', (e) => {
      e.stopImmediatePropagation()
      const currentBullet = e.currentTarget
      const dataID = currentBullet.getAttribute('data-id')
      const parentContainer = currentBullet.parentElement.parentElement

      parentContainer.querySelector('.bullet.active').classList.remove('active')
      currentBullet.classList.add('active')

      const currentImg = parentContainer.querySelector('[src]')
      const currentImgSrc = currentImg.src
      currentImg.removeAttribute('src')
      currentImg.setAttribute('data-src', currentImgSrc)
      currentImg.style.display = 'none'

      const selectedImg = parentContainer.querySelector('[data-id="'+dataID+'"]')
      selectedImg.src = selectedImg.getAttribute('data-src')
      selectedImg.style.display = 'block'
    })
  }
}
